import type { RouteRecordRaw } from 'vue-router';

const integrationRoutes: RouteRecordRaw[] = [
  {
    path: '/integration',
    name: 'integration',
    component: () => import('@/domains/integration/views/IntegrationHubView.vue'),
    meta: { renderer: 'native' },
  },
  {
    path: '/integration/ranger',
    name: 'integration-ranger',
    component: () => import('@/domains/integration/views/RangerView.vue'),
    meta: { renderer: 'native' },
  },
  {
    path: '/integration/pagerduty',
    name: 'integration-pagerduty',
    component: () => import('@/domains/integration/views/PagerDutyView.vue'),
    // Whole-page gate: without alert perm AppLayout renders <Unauthorized/> in
    // place (hasPerm('alert@all') already ORs the allObj@allAct passport),
    // matching legacy's hasAlertPerm → <Page401/> swap.
    meta: { renderer: 'native', perms: ['alert@all'] },
  },
];

export default integrationRoutes;
